export type MealSlot = 'breakfast' | 'lunch' | 'dinner' | 'snack';

export interface CalendarEntryRecipe {
  id: number;
  title: string;
  kcal_per_portion: number;
}

export interface CalendarEntry {
  id: number;
  date: string;
  meal_type: MealSlot;
  recipe: CalendarEntryRecipe;
  portions: number;
  total_kcal: number;
  total_protein: number;
  total_carbs: number;
  total_fat: number;
  total_weight_g: number;
  is_leftover: boolean;
}

export interface CalendarDaySummary {
  kcal: number;
  protein_g: number;
  carbs_g: number;
  fat_g: number;
}

export interface WeekDay {
  iso: string;
  weekdayShort: string;
  dayOfMonth: number;
  isToday: boolean;
}

export interface MonthCell {
  iso: string;
  dayOfMonth: number;
  inMonth: boolean;
  isToday: boolean;
  isSelected: boolean;
  entries: CalendarEntry[];
}

export const MEAL_SLOTS: readonly MealSlot[] = [
  'breakfast',
  'lunch',
  'dinner',
  'snack',
];

export const MEAL_DEFAULT_TIME: Readonly<Record<MealSlot, string>> = {
  breakfast: '08:00',
  lunch: '12:30',
  dinner: '19:00',
  snack: '16:00',
};

export const MEAL_LABEL: Readonly<Record<MealSlot, string>> = {
  breakfast: 'BREAKFAST',
  lunch: 'LUNCH',
  dinner: 'DINNER',
  snack: 'SNACK',
};

export const MEAL_ICON: Readonly<Record<MealSlot, string>> = {
  breakfast: '🌅',
  lunch: '☀️',
  dinner: '🌙',
  snack: '🍿',
};

export function isMealSlot(v: string): v is MealSlot {
  return (MEAL_SLOTS as readonly string[]).includes(v);
}
